const events = new Map()
const data = new Map()

class Event {
  constructor() {
    data.set(this, {});
    events.set(this, {});
  }

  on(type, listener, priority = 0) {
    let target = events.get(this)

    type.split(' ').forEach(evt => {
      if (!target[evt]) {
        target[evt] = {}
      }
      let handlers = target[evt]
      if (!handlers[priority]) handlers[priority] = []

      let listeners = handlers[priority]
      if (!listeners.find(listener)) listeners.push(listener)
    })
    return this
  }

  off(type, listener) {
    let target = events.get(this)
    if(!listener) {
        target = {}
        return
    }

    let handlers = target[type]
    if(!handlers) return

    let priorities = Object.keys(handlers)
    if(!priorities || priorities.length === 0) return

    priorities.forEach(i => {
        let listeners = handlers[i]
        let idx = listeners.findIndex(listener)
        if(idx >= 0) listeners.splice(idx, 1) // delete it/them
        
        if(listeners.length === 0) {
          delete handlers[i]
        }

    })
    return this
  }

  trigger(type, ...rest) {

    let handlers = events.get(this)[type]
    if(!handlers) return

    let priorities = Object.keys(handlers)
    if(!priorities || priorities.length === 0) return
    if(priorities.length > 1) priorities = priorities.sort((a, b) => a - b)

    let listeners = []

    priorities.forEach(i => {
        let listeners = handlers[i]
        if(listeners.length){
          listeners.forEach(listener => {
            if(typeof listener === 'function') {
                // this.call(handler, ...args) // 会绑定this
                listener({type},...rest) // 不会绑定this，其实可以在on的时候用bind去绑定
            }
          })
        }
    })

    return this
  }
  
  extend(dist){
    for(let i in dist){
      this[i] = dist[i]
    }
  }

}

export default Event